export default {
	init() {
		window.addEventListener("scroll", () => {
			const elements = document.querySelectorAll('.rellax');
			for(let i=0;i<elements.length;i++) {
	      if (this.isInViewport(elements[i]) && !elements[i].classList.contains("active") ) {
	        document.querySelector('.rellax.active').classList.remove("active");
	        elements[i].classList.add("active");
	      }
	    }
		});

	},
	isInViewport(elem) {
		var bounding = elem.getBoundingClientRect();
		const top = bounding.top;
		const left = bounding.left;
		const right = bounding.right;
		const bottom = bounding.bottom-64;

		return (
			top >= 0 &&
			left >= 0 &&
			bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
			right <= (window.innerWidth || document.documentElement.clientWidth)
		);
	}
}